import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback as r, useState as b } from "react";
function c() {
  var u = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var _b = b(u),
    _b2 = _slicedToArray(_b, 2),
    t = _b2[0],
    l = _b2[1],
    g = r(function (e) {
      return l(e);
    }, [t]),
    s = r(function (e) {
      return l(function (a) {
        return a | e;
      });
    }, [t]),
    m = r(function (e) {
      return (t & e) === e;
    }, [t]),
    n = r(function (e) {
      return l(function (a) {
        return a & ~e;
      });
    }, [l]),
    F = r(function (e) {
      return l(function (a) {
        return a ^ e;
      });
    }, [l]);
  return {
    flags: t,
    setFlag: g,
    addFlag: s,
    hasFlag: m,
    removeFlag: n,
    toggleFlag: F
  };
}
export { c as useFlags };